import React from 'react';

import './missing.scss';

export var Missing = function Missing(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      _ref$style = _ref.style,
      style = _ref$style === undefined ? {} : _ref$style,
      _ref$value = _ref.value,
      value = _ref$value === undefined ? '' : _ref$value;
  return React.createElement(
    'span',
    { className: 'i18n-missing ' + className, style: style },
    value
  );
};